export const MuiCheckbox = () => ({
  defaultProps: {
    disableRipple: true,
  },
});
